<template>
  <div class="hello container">
    <div
      v-if="loading === true"
      style="
        background-color: rgba(56, 74, 35, 0.67);
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 999;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <HourGlass></HourGlass>
    </div>
    <h3>Personas con suscripciones</h3>
    <div class="container mt-3 mb-3">
      <div class="container mb-3">
      </div>
      <vue-good-table
        :columns="columns"
        :rows="arrayPersonas"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 10,
          position: 'top',
          perPageDropdown: [15, 20, 25],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Proximo',
          prevLabel: 'Anterior',
          rowsPerPageLabel: 'Filas por Pagina',
          ofLabel: 'de',
          pageLabel: 'Pagina', // for 'pages' mode
          allLabel: 'Todas',
        }"
        :search-options="{
          enabled: true,
          trigger: 'enter',
          skipDiacritics: true,
          placeholder: 'Buscar',
        }"
      />

      <!-- <table class="table table-hover">
        <thead>
          <tr>
            <th v-for="col in columnas" v-bind:key="col" scope="col">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="per in personas" v-bind:key="per.id">
            <th scope="row">{{per.dni}}</th>
            <td>{{per.apellidos}}</td>
            <td>{{per.nombres}}</td>
            <td>{{per.email}}</td>
          </tr>
        </tbody>
      </table>-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { HourGlass } from "vue-loading-spinner";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import { environment } from "../../environments/environment";

export default {
  components: {
    // ListSelect, DatePicker,
    HourGlass,
    VueGoodTable,
  },
  data() {
    return {
      columns: [
        {
          label: "Apellidos",
          field: "apellidos",
        },
        {
          label: "Nombre",
          field: "nombres",
        },
        {
          label: "Telefono",
          field: "telefono",
        },
        {
          label: "DNI",
          field: "dni",
        },
      ],
      arrayPersonas: [],
      localidad: {
        id: "",
        name: "",
      },
      loading: false,
      columnas: ["DNI", "Apellidos", "Nombres", "Email"],
      descuentos: [],
      companias: [],
      personas: [],
      suscripcion: {},
      descuento: {},
      provincias: [],
      localidades: [],
      idProvincia: "",
      idLocalidad: "",
      rangoFechas: [new Date(2020, 0, 1), new Date(2020, 0, 31)],
      fechaDesde: new Date(),
      fechaHasta: new Date(),
      conFiltros: false,
      token: "",
    };
  },
  methods: {
    onClickComplete() {
      this.loading = true;
      axios({
        url: environment.API_URL + "reportes",
        method: "GET",
        responseType: "blob",
        headers: { Authorization: "Token " + this.token },
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "reporte.xlsx");
          document.body.appendChild(fileLink);

          fileLink.click();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    onClickApplyFilters() {
      this.conFiltros = true;
      const anioDesdeString = this.fechaDesde.getFullYear();
      const mesDesdeString = this.fechaDesde.getMonth() + 1;
      const diaDesdeString = this.fechaDesde.getDate();

      const anioHastaString = this.fechaHasta.getFullYear();
      const mesHastaString = this.fechaHasta.getMonth() + 1;
      const diaHastaString = this.fechaHasta.getDate();

      const fechaDesdeString =
        anioDesdeString + "-" + mesDesdeString + "-" + diaDesdeString;

      const fechaHastaString =
        anioHastaString + "-" + mesHastaString + "-" + diaHastaString;

      axios
        .get(
          environment.API_URL +
            "cliente/filtros?idLocalidad=" +
            this.localidad.id +
            "&fechaDesde=" +
            fechaDesdeString +
            "&fechaHasta=" +
            fechaHastaString,
          {
            headers: { Authorization: "Token " + this.token },
          }
        )
        .then((response) => {
          this.personas = response.data;
          this.arrayPersonas = response.data;
          this.conFiltros = false;
        });
    },
    onClickWithFilters() {
      const anioDesdeString = this.fechaDesde.getFullYear();
      const mesDesdeString = this.fechaDesde.getMonth() + 1;
      const diaDesdeString = this.fechaDesde.getDate();

      const anioHastaString = this.fechaHasta.getFullYear();
      const mesHastaString = this.fechaHasta.getMonth() + 1;
      const diaHastaString = this.fechaHasta.getDate();

      const fechaDesdeString =
        anioDesdeString + "-" + mesDesdeString + "-" + diaDesdeString;

      const fechaHastaString =
        anioHastaString + "-" + mesHastaString + "-" + diaHastaString;

      axios({
        url:
          environment.API_URL +
          "reportes/filtros?idLocalidad=" +
          this.localidad.id +
          "&fechaDesde=" +
          fechaDesdeString +
          "&fechaHasta=" +
          fechaHastaString,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: "Token " + this.token },
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "reporte.xlsx");
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    cambioFecha() {
      this.fechaDesde = this.rangoFechas[0];
      this.fechaHasta = this.rangoFechas[1];
    },
    buscarLocalidades: async function (event) {
      this.idProvincia = event.target.value;

      if (this.idProvincia !== "") {
        axios
          .get(environment.API_URL + "localidad/provincia/" + this.idProvincia)
          .then((response) => {
            this.localidades = response.data;
          });
      }
    },
    onSelect(pLocalidad) {
      this.localidad = pLocalidad;
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    axios.get(environment.API_URL + "provincia").then((response) => {
      this.provincias = response.data;
    });

    axios
      .get(environment.API_URL + "cliente", {
        headers: { Authorization: "Token " + this.token },
      })
      .then((response) => {
        this.arrayPersonas = response.data;
        this.personas = response.data;
      });
  },
};
</script>

<style scoped>
/************************ */

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#app .title {
  margin-bottom: 30px;
}

#app .items-per-page {
  height: 100%;
  display: flex;
  align-items: center;
  color: #337ab7;
}

#app .items-per-page label {
  margin: 0 15px;
}

/* Datatable CSS */
.v-datatable-light .header-item {
  cursor: pointer;
  color: #337ab7;
  transition: color 0.15s ease-in-out;
}

.v-datatable-light .header-item:hover {
  color: #ed9b19;
}

.v-datatable-light .header-item.no-sortable {
  cursor: default;
}
.v-datatable-light .header-item.no-sortable:hover {
  color: #337ab7;
}

.v-datatable-light .header-item .th-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  font-weight: bold;
}

.v-datatable-light .header-item .th-wrapper.checkboxes {
  justify-content: center;
}

.v-datatable-light .header-item .th-wrapper .arrows-wrapper {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  justify-content: space-between;
}

.v-datatable-light .header-item .th-wrapper .arrows-wrapper.centralized {
  justify-content: center;
}

.v-datatable-light .arrow {
  transition: color 0.15s ease-in-out;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
}

.v-datatable-light .arrow.up {
  border-bottom: 8px solid #337ab7;
}

.v-datatable-light .arrow.up:hover {
  border-bottom: 8px solid #ed9b19;
}

.v-datatable-light .arrow.down {
  border-top: 8px solid #337ab7;
}

.v-datatable-light .arrow.down:hover {
  border-top: 8px solid #ed9b19;
}

.v-datatable-light .footer {
  display: flex;
  justify-content: space-between;
  width: 500px;
}

#app .v-datatable-light .row-7 .column-4 {
  color: steelblue;
}

#app .v-datatable-light .row-1 .column-2 {
  color: green;
}

#app .v-datatable-light .row-2 .column-1 {
  color: red;
}

#app .v-datatable-light .row-3 {
  color: pink;
}

#app .v-datatable-light .column-5 {
  color: goldenrod;
}

#app .v-datatable-light .row-3 .column-5 {
  color: purple;
}

/* End Datatable CSS */

/* Pagination CSS */
.v-datatable-light-pagination {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  width: 300px;
  height: 30px;
}

.v-datatable-light-pagination .pagination-item {
  width: 30px;
  margin-right: 5px;
  font-size: 16px;
  transition: color 0.15s ease-in-out;
}

.v-datatable-light-pagination .pagination-item.selected {
  color: #ed9b19;
}

.v-datatable-light-pagination .pagination-item .page-btn {
  background-color: transparent;
  outline: none;
  border: none;
  color: #337ab7;
  transition: color 0.15s ease-in-out;
}

.v-datatable-light-pagination .pagination-item .page-btn:hover {
  color: #ed9b19;
}

.v-datatable-light-pagination .pagination-item .page-btn:disabled {
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.65;
}
/* END PAGINATION CSS */

/* ITEMS PER PAGE DROPDOWN CSS */
.item-per-page-dropdown {
  background-color: transparent;
  min-height: 30px;
  border: 1px solid #337ab7;
  border-radius: 5px;
  color: #337ab7;
}
.item-per-page-dropdown:hover {
  cursor: pointer;
}
/* END ITEMS PER PAGE DROPDOWN CSS */

.v-datatable-light tbody tr td:nth-of-type(3) {
  color: red;
  text-align: left;
}

/******************** */

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.shadow2 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.shadow2:hover {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}
</style>
